import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {ApiUrl} from '@emm/core/util/api-url.token';
import {API, APIParams} from '@emm/core/util/api-constants';
import {standardRetry} from '@emm/core/util/rx.util';
import {ConsumerType} from '@emm/core/models/consumer-type.model';
import {Consumer} from '@emm/core/models/consumer.model';

@Injectable({
  providedIn: 'root',
})
export class ConsumerService {
    constructor(
        @Inject(ApiUrl) private apiUrl: string,
        private http: HttpClient
        ) {
    }

    public getAllConsumers(): Observable<Consumer[]> {
        const url = `${this.apiUrl}${API.AllConsumers}menu-builder`;
        return this.http.get(url).pipe(
            // TODO: Make interface objects for http responses
            map((response: any) => response),
            standardRetry()
    );
  }

  public deleteConsumer(consumerTag: string): Observable<any> {
    const url = `${this.apiUrl}${APIParams.DeleteConsumer(consumerTag)}`;
    return this.http.delete(url).pipe(standardRetry());
  }

  public getConsumerTypes(): Observable<ConsumerType[]> {
    return this.http.get(this.apiUrl + '/destination-types').pipe(
      map((response) => response['destinationTypes']),
      standardRetry()
    );
  }

  public createConsumerType(consumerType: ConsumerType): Observable<any> {
    return this.http
      .post(`${this.apiUrl}/destination-types`, consumerType)
      .pipe(standardRetry());
  }
}
